var styles = {"fontElementMap":"XTUlv","orderedlist":"epCSU","bulletedlist":"udufI","listItem":"_1722l"};

export { styles as s };
//# sourceMappingURL=lists-11b7a02d.js.map
